import React from "react";
import { styled } from "../stitches.config";
import { body } from "./commonStyles/Fonts";
import Avatar from "./atoms/Avatar";

import { Author } from "./components/AtavistAuthors";

interface AuthorSimpleProps {
    authors: Author[];
    border?: boolean;
    authorSize?: "extrasmall" | "small" | "big";
}

export const AuthorSimple: React.FC<AuthorSimpleProps> = ({
    authors,
    border = false,
    authorSize = "small",
}) => {
    return (
        <AuthorSimpleWrapper href="#autorzy-artykulu">
            {authors.map(author => (
                <Avatar
                    src={author?.img}
                    url={author?.url || ""}
                    border={border}
                    size={authorSize}
            />
            ))}
            <a className={body()} href="#autorzy-artykulu">
                {authors.length === 0 ? '1 autor artykułu' : `${authors.length} autorów artykułu`}
            </a>
        </AuthorSimpleWrapper>
    );
};


const AuthorSimpleWrapper = styled("a", {
    display: "flex",
    alignItems: "center",
    "a": {
        color: "$primary",
        textDecoration: "underline",
    },
    "& .avatar": {
        width: "40px",
        height: "40px",
        borderRadius: "40px",
        flexShrink: 0,
        marginRight: "24px",
        pointerEvents: "none",
    },
});

export default AuthorSimple;
